import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/src/app/global-error.tsx");
